import { Component, OnInit } from '@angular/core';
import { DataGridTemplate } from '../../../../../shared/data-grid/data-grid.template';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormDialogTemplate } from '../../../../../shared/form-dialog/form-dialog.template';
import { CtwrDesignPhaseService } from '../../../ctwr.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-design-phases',
  templateUrl: './design-phases.component.html',
  styleUrls: ['./design-phases.component.scss']
})
export class DesignPhasesComponent extends DataGridTemplate implements OnInit {

  editForm: FormGroup;
  formDialog: FormDialogTemplate;
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly designPhaseService: CtwrDesignPhaseService,
  ) {
    super();
    this.controls.edit = false;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit() {
    this.formDialog = new FormDialogTemplate();
    this.modal = true;
    this.sortable = true;
    this.filterable = 'menu';
    this.gridState.sort = [{ dir: 'asc', field: 'Name' }];

    this.editForm = this.formBuilder.group({
      Id: [],
      Name: ['', Validators.compose([Validators.required, Validators.maxLength(65)])],
    })

    this.formDialog.initilize("Design Phase", this.editForm, this.formDialogTabs);
  }


  create(parentEditDataItem: any): void {
    this.formDialog.isNew = true;
    this.formDialog.next({});
  }

  read(opts: any): Promise<any> {
    return opts.force ?
      this.designPhaseService.read('') :
      Promise.resolve(this.designPhaseService.value);
  }

  edit(dataItem: any): void {
    this.formDialog.isNew = false;
    this.formDialog.next(dataItem);
  }

  save(dataItem: any, isNew: boolean): Promise<any> {
    return this.designPhaseService.save(this.editForm.value, isNew, '', false)
  }

  delete(dataItem: any): Promise<any> {
    return this.designPhaseService.remove("/" + dataItem.Id, false)
  }

  columns: any[] = [
    {
      field: 'Name',
      title: 'Name',
    },
  ]

  formControls = [
    {
      type: 'text',
      title: 'Name',
      name: 'Name',
      textField: 'Description',
      valueField: 'Id',
      placeholder: 'Enter a Design Phase Name',
      stretch: true,
      invalidText: 'Input must be between 1 and 65 characters.'
    },
  ]

  formDialogTabs = [
    {
      title: "Design Phase",
      selected: true,
      formControls: this.formControls
    },
  ]
}
